import { useTranslation } from "react-i18next";

import { WarningModal } from "#components/molecules/Modal/WarningModal";
import { formatPercentage } from "shared";

type Props = {
  opened: boolean;
  savedBilledShare: number;
  newBilledShare: number;
  isConfirming?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const SyncBilledShareModal = ({
  opened,
  savedBilledShare,
  newBilledShare,
  isConfirming = false,
  onConfirm,
  onCancel,
}: Props) => {
  const { t } = useTranslation();

  return (
    <WarningModal
      opened={opened}
      title={t("optimizations.detail.syncBilledShare.title", {
        from: formatPercentage(savedBilledShare),
        to: formatPercentage(newBilledShare),
      })}
      description={t("optimizations.detail.syncBilledShare.description")}
      primaryText={t("optimizations.detail.syncBilledShare.confirm")}
      secondaryText={t("optimizations.detail.syncBilledShare.cancel")}
      closeText={t("common.close")}
      primaryLoading={isConfirming}
      onPrimary={onConfirm}
      onSecondary={onCancel}
      onClose={onCancel}
    />
  );
};
